import React from 'react';
import Drawer from './Drawer.jsx';
export default function LowerProductSwitcher(props) {
  const sanitizeHtml = html => {
    const tempEl = document.createElement('div');
    tempEl.innerHTML = html;
    return { __html: tempEl.innerHTML }
  }

  class LowerSwitcherInfo extends React.PureComponent {
    constructor(props) {
      super();
      this.state = { open: false };

      this._close = this._close.bind(this);
    }

    _close() {
      this.setState({ open: false })
    }

    render() {

      return <React.Fragment>
        <span onClick={(e) => { this.setState({ open: true }) }}>
          <svg class="svg-icon icon-info" xmlns="http://www.w3.org/2000/svg"><use xlinkHref="#reuse-info"></use></svg>
        </span>
        <Drawer open={this.state.open} content={this.props.content} heading={this.props.heading} contentClass="pricing-philosophy pricing-philosophy-how-we-do-it afterpay-drawer" _close={this._close} mountOnEnter={true} unmountOnExit={true}>
        </Drawer>
      </React.Fragment>
    }
  }

  const switcherItems_1 = [];
  for (let i = 1; i < 5; i++) {
    if (props.metafields.variant_selector_1[`handle_${i}`] && props.metafields.variant_selector_1[`text_${i}`]) {
      const item = {};
      item.handle = props.metafields.variant_selector_1[`handle_${i}`];
      item.label = props.metafields.variant_selector_1[`text_${i}`];
      let product_tags;
      if (props.variant_selectors_products) product_tags = props.variant_selectors_products.find(x => x.handle == props.metafields.variant_selector_1[`handle_${i}`])
      product_tags && (item.tags = product_tags.tags);
      switcherItems_1.push(item)
    }
  }
  const switcherItems_2 = [];
  for (let i = 1; i < 5; i++) {
    if (props.metafields.variant_selector_2[`handle_${i}`] && props.metafields.variant_selector_2[`text_${i}`]) {
      const item = {};
      item.handle = props.metafields.variant_selector_2[`handle_${i}`];
      item.label = props.metafields.variant_selector_2[`text_${i}`];
      let product_tags;
      if (props.variant_selectors_products) product_tags = props.variant_selectors_products.find(x => x.handle == props.metafields.variant_selector_2[`handle_${i}`]);
      product_tags && (item.tags = product_tags.tags);
      switcherItems_2.push(item);
    }
  }
  const switcherItems_3 = [];
  for (let i = 1; i < 5; i++) {
    if (props.metafields.variant_selector_3[`handle_${i}`] && props.metafields.variant_selector_3[`text_${i}`]) {
      const item = {};
      item.handle = props.metafields.variant_selector_3[`handle_${i}`];
      item.label = props.metafields.variant_selector_3[`text_${i}`];
      let product_tags;
      if (props.variant_selectors_products) product_tags = props.variant_selectors_products.find(x => x.handle == props.metafields.variant_selector_3[`handle_${i}`]);
      product_tags && (item.tags = product_tags.tags);
      switcherItems_3.push(item);
    }
  }

  const _changeProduct = (e, newProduct) => {
    e.preventDefault();
    props.onProductChange(newProduct, props.currentVariant);
  }

  let className = 'option-wrapper option-handle-width option-add-selector lower-option-handle-width';
  if ((switcherItems_1.length > 0 || switcherItems_2.length > 0 || switcherItems_3.length > 0)) {
    return (
      <div class="lower_options-container">
        {props.metafields.variant_selector_1.title && switcherItems_1.length ?
          <div className={`${className}`}>
            <div className="option-header">
              <span className="option-name">
                {props.metafields.variant_selector_1.title}:
              </span>
              {
                props.metafields.variant_selector_1.more_info ?
                  <LowerSwitcherInfo heading={props.metafields.variant_selector_1.title} content={props.metafields.variant_selector_1.more_info}></LowerSwitcherInfo>
                  : null
              }
            </div>
            <div className="option-values">
              {switcherItems_1.map((product, i) => {
                let itemClassName = 'option-value';
                const locale = window.Shopify.locale && window.Shopify.locale !== 'en' ? `/${window.Shopify.locale}` : '';
                product.handle === props.product.handle ? itemClassName += ' selected' : null
                props.option1 && props.option1.startsWith('Wide') && (!product.tags || !product.tags.includes(`width:${props.option1}`)) ? itemClassName += ' incompatible-width' : null;
                return <div className={itemClassName} key={i}>
                  <span className="option-value-name">
                    <span className="option-value-inner">
                      {product.label}
                    </span>
                  </span>
                  <a href={`${locale}/products/${product.handle}`} onClick={e => _changeProduct(e, product)} className="option-value-input">
                  </a>
                </div>
              })}
            </div>
          </div> : null
        }
        {props.metafields.variant_selector_2.title && switcherItems_2.length ?
          <div className={`${className}`}>
            <div className="option-header">
              <span className="option-name">
                {props.metafields.variant_selector_2.title}:
              </span>
              {
                props.metafields.variant_selector_2.more_info ?
                  <LowerSwitcherInfo heading={props.metafields.variant_selector_2.title} content={props.metafields.variant_selector_2.more_info}></LowerSwitcherInfo>
                  : null
              }
            </div>
            <div className="option-values">
              {switcherItems_2.map((product, i) => {
                let itemClassName = 'option-value';
                const locale = window.Shopify.locale && window.Shopify.locale !== 'en' ? `/${window.Shopify.locale}` : '';
                product.handle === props.product.handle ? itemClassName += ' selected' : null
                props.option1 && props.option1.startsWith('Wide') && (!product.tags || !product.tags.includes(`width:${props.option1}`)) ? itemClassName += ' incompatible-width' : null;
                return <div className={itemClassName} key={i}>
                  <span className="option-value-name">
                    <span className="option-value-inner">
                      {product.label}
                    </span>
                  </span>
                  <a href={`${locale}/products/${product.handle}`} onClick={e => _changeProduct(e, product)} className="option-value-input">
                  </a>
                </div>
              })}
            </div>
          </div> : null
        }
        {props.metafields.variant_selector_3.title && switcherItems_3.length ?
          <div className={`${className}`}>
            <div className="option-header">
              <span className="option-name">
                {props.metafields.variant_selector_3.title}:
              </span>
              {
                props.metafields.variant_selector_3.more_info ?
                  <LowerSwitcherInfo heading={props.metafields.variant_selector_3.title} content={props.metafields.variant_selector_3.more_info}></LowerSwitcherInfo>
                  : null
              }
            </div>
            <div className="option-values">
              {switcherItems_3.map((product, i) => {
                let itemClassName = 'option-value';
                const locale = window.Shopify.locale && window.Shopify.locale !== 'en' ? `/${window.Shopify.locale}` : '';
                product.handle === props.product.handle ? itemClassName += ' selected' : null
                props.option1 && props.option1.startsWith('Wide') && (!product.tags || !product.tags.includes(`width:${props.option1}`)) ? itemClassName += ' incompatible-width' : null;
                return <div className={itemClassName} key={i}>
                  <span className="option-value-name">
                    <span className="option-value-inner">
                      {product.label}
                    </span>
                  </span>
                  <a href={`${locale}/products/${product.handle}`} onClick={e => _changeProduct(e, product)} className="option-value-input">
                  </a>
                </div>
              })}
            </div>
          </div> : null
        }
      </div>
    )
  }

  return (null);
}